<template>
  <VAutocomplete
    :value="selected"
    :label="$t('statistic.sub_id')"
    :loading="loading.subId"
    :items="subIds"
    :search-input.sync="search"
    :filter="filterDomainSubid"
    item-value="subId"
    item-text="fdomain"
    debounce-search="1500"
    multiple
    multi-line
    cache-items
    class="ml-3 pr-4"
    chips
    @input="e => $emit('input', e)"
  >
    <template
      slot="selection"
      slot-scope="data"
    >
      <VChip
        :key="JSON.stringify(data.item)"
        :selected="data.selected"
        class="chip--select-multi"
        close
        @input="data.parent.selectItem(data.item)"
      >
        {{ data.item.fdomain }} | {{ data.item.subId }}
      </VChip>
    </template>
    <template
      slot="item"
      slot-scope="data"
    >
      <template>
        <VListTileContent v-if="data.item.fdomain">
          {{ data.item.fdomain }} | {{ data.item.subId }}
        </VListTileContent>
        <VListTileContent v-else>
          {{ data.item }}
        </VListTileContent>
      </template>
    </template>
  </VAutocomplete>
</template>

<script>
export default {
  name: 'SiteDomainDsp',
  inheritAttrs: false,
  model: {
    prop: 'selected',
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    id: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      subIds: [],
      search: '',
    };
  },
  watch: {
    async search(value) {
      if (undefined !== value
        && value !== null
        && this.id
        && value.length > 3
        && !this.loading
        && !this.subIds.find(item => item.fdomain === value || item.subId === value)) {
        this.loading = true;
        try {
          const { data: { data: items } } = await this.$api.postDspStatisticFindDomains({
            value,
            campaign: this.id,
          });
          this.subIds = this.subIds.concat(items.data);
        } finally {
          this.loading = false;
        }
      }
    },
  },
  methods: {
    filterDomainSubid(item, queryText) {
      if (!queryText || !item) {
        return false;
      }

      return Object.values(item).findIndex(
        v => v.toString()
          .toLowerCase()
          .indexOf(queryText.toString().toLowerCase()) > -1,
      ) > -1;
    },
  },
};
</script>
